import React, { useState } from "react";
import { Container, Typography, Box, Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import NFTCard from "../components/NFTCard";
import nftItems from "../data/nftData";

const categories = ["전체", "예술", "음악", "영상", "공예", "학습", "기타"]; /*임시 카테고리*/

const Market = () => {
  const [selectedCategory, setSelectedCategory] = useState("전체");
  const filteredItems =
    selectedCategory === "전체"
      ? nftItems
      : nftItems.filter((item) => item.category === selectedCategory);

  return (
    <Container sx={{ mt: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
      마켓
      </Typography>

      {/* 카테고리 필터 */}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 4 }}>
        {categories.map((cat) => (
          <Button
            key={cat}
            variant={selectedCategory === cat ? "contained" : "outlined"}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </Button>
        ))}
      </Box>

      {/* NFT 카드 그리드 */}
      <Grid container spacing={3}>
        {filteredItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Link to={`/detail/${item.name}`}>  {/* 일단 아이템의 name을 사용해 상세 페이지 연결 */}
            <NFTCard item={item} index={index} />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Market;
